// extracted by mini-css-extract-plugin
export default {"addToCart":"AddToCart_addToCart__toMok","animationDiv":"AddToCart_animationDiv__3qKhO","buttonContainer":"AddToCart_buttonContainer__ft4+-","btn":"AddToCart_btn__0eY7E"};